import styled from 'styled-components';
import { theme } from '../../theme';

export const DivWrapper = styled.div`
margin-top: 30px;

.order-production-status-error-modal {
  &__textarea {
    font-weight: 600;
    max-height: 50vh !important;
    border-radius: 5px;
    border-color: ${theme.colors.secondary};
    padding: 2rem;
    color: ${theme.colors.textPrimary};
  }

  &__copy-btn {
    margin-top: 15px;
    font-weight: 600;
    padding: 0 10px;
  }
}
`;
